"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AutocompleteDebounce = _interopRequireDefault(require("./AutocompleteDebounce"));

var _ListItem = require("../../ListItem");

var _excluded = ["form", "field", "fetchOptions", "user"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ProductAutocomplete = function ProductAutocomplete(_ref) {
  var form = _ref.form,
      field = _ref.field,
      fetchOptions = _ref.fetchOptions,
      user = _ref.user,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_AutocompleteDebounce["default"], _extends({
    fetchOptions: fetchOptions,
    getOptionLabel: getProductOptionLabel,
    getOptionSelected: getProductOptionSelected,
    renderOption: renderProductOption,
    filterOptions: filterOptions,
    field: field,
    form: form
  }, props));
};

var _default = ProductAutocomplete; // Tags

exports["default"] = _default;

var getProductOptionSelected = function getProductOptionSelected(option, value) {
  return productSelected(option) === productSelected(value);
};

var getProductOptionLabel = function getProductOptionLabel(option) {
  return option === "" ? "" : productSelected(option);
};

var renderProductOption = function renderProductOption(option, state) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_ListItem.ItemProduct, {
    id: option.id,
    brandName: option.productBrand && option.productBrand.brand_name,
    label: option.label,
    status: option.status
  }));
};

var productSelected = function productSelected(product) {
  var temp = [];
  product && product.productBrand && product.productBrand.brand_name && temp.push(product.productBrand.brand_name);
  product && product.label && temp.push(product.label);
  product && product.id && temp.push("[".concat(product.id, "]"));
  return temp.join(" ");
};

var filterOptions = function filterOptions(options, state) {
  return options.filter(function (v) {
    return productSelected(v).toLowerCase().includes(state.inputValue.toLowerCase());
  });
};